<template>
    <div class="row">
        <div class="col-12">
            <div class="row tit_page">
				<div class="col-12">
					<div class="float-left">
						<h1>Central de cobranças</h1>
					</div>
					<div class="back float-right">
						<a @click="$router.go(-1)"><span><img src="/static/assets/images/ico-back.svg"> Voltar</span></a>
					</div>
				</div>
            </div>
            <hr class="divider">
            <div v-if="width > 1100" class="row">
                <div class="col-12 col-md-8 col-lg-8">
                    <div class="row">
                        <div class="col-12 d-flex justify-content-between align-items-center">
                            <h2>Solicitações</h2>
                            <div class="d-flex align-items-center">
                                <span class="font-weight-bold pr-2">Filtros</span>
                                <select class="form-control" v-model="status">
                                    <option v-for="(item) in statusOption" :key="item" :value="item.value">{{ item.label }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <hr class="divider">
                    <div v-if="loading" class="d-flex justify-content-center">
                        <Loading />
                    </div>
                    <div v-else class="row">
                        <div class="col-12 table-responsive"> 
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col" width="100">ID</th>
                                        <th scope="col" width="70">Status</th>
                                        <th scope="col" width="35%">Empresa</th>
                                        <th scope="col">Valor investido</th>
                                        <th scope="col">Data do invest.</th>
                                        <!-- <th scope="col">&nbsp;</th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in solicitacoes.SolicitacaoProcesso" :key="(item + index)">
                                        <!-- <th scope="row"><a href="#/investimentos/central-de-cobranca/status-cobranca">#{{item.OportunidadeID}}</a></th> -->
                                        <td>#{{ item.OportunidadeID }}</td>
                                        <td class="d-flex justify-content-center">
                                            <span :class="'circle ' + 'status-' + abreviaStatus(item.StatusAtraso)"></span>
                                        </td>
                                        <td>{{item.NomeEmpresa ? item.NomeEmpresa : ''}}</td>
                                        <td>{{item.ValorInvestido ? formatarDinheiro(item.ValorInvestido) : formatarDinheiro(0)}}</td>
                                        <td >{{ formataData(item.DataInvestimento) }}</td>
                                        <td>
                                            <router-link :to="{name: 'VisualizarStatusCobranca', query: { id: item.SolicitacaoID }}" title="Mais detalhes" append>Mais detalhes</router-link>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <!-- INICIO PAGINAÇAO -->
                    <div class="paginacao">
                        <Pagination
                            :paginasTotais="this.Paginas"
                            :paginaAtual="this.indexPage"
                            :navigate="(rota)=>this.paginacao(rota-1)"
                        />
                    </div>
                    <!-- FINAL PAGINAÇÃO -->
                </div>
                <aside class="col-12 col-md-4 col-lg-4">
                    <div v-if="loadingAux" class="border rounded p-4">
                        <Loading />
                    </div>
                    <div v-else class="border rounded p-4">
                        <ul>
                            <li class="header d-flex justify-content-between align-items-center">
                                <h3>Total de solicitações</h3>
                                <span>{{ total.TotalSolicitacoes ? parseInt(total.TotalSolicitacoes) : 0 }}</span>
                            </li>
                            <li v-for="item in total.TotalStatus" :key="item.Status" class="list d-flex justify-content-between align-items-center">
                                <div class="d-flex align-items-center">
                                    <span :class="'circle ' + 'status-' + abreviaStatus(item.Status)"></span>
                                    {{ item.Status ? item.Status == '15 dias' ? '1 a 15 dias' : item.Status : "" }}
                                    <!-- <at-popover trigger="hover" :content="(item.tooltip)" placement="right">
                                        <i class="fas fa-info-circle" style="font-size: 14px;"></i>
                                    </at-popover> -->
                                </div>
                                <span class="value">{{ item.Total ? parseInt(item.Total) : 0 }}</span>
                            </li>
                            <li class="total d-flex justify-content-between align-items-center">
                                <span>Total</span>
                                <span>{{ total.TotalSolicitacoes ? parseInt(total.TotalSolicitacoes) : 0 }}</span>
                            </li>
                        </ul>
                    </div>
                </aside>
            </div>
            <div v-else class="row show-mobile">
                <div class="alert alert-warning" role="alert">
                    Para ter acesso completo a central de cobranças da plataforma, acesse a partir de um desktop ou notebook.
                </div>
            </div>
        </div>
    </div>
   
</template>

<script>

    import CentralService from '../services/api/centralCobranca';
    import Loading from '@/components/SimpleLoader'

    import * as mutationTypes from '@/store/mutation-types.js'
    import Masker from '../utils/masker'
    import Pagination from '@/components/Pagination';

    export default {
        data() {
            return {
                status: '',
                investidor: {},
                id:"",
                data: {},
                solicitacoes: {},
                total: {},
                width: 0,
                indexPage: 1,
                indexPageFiltro: 1,
                Paginas:0,
                loading: true,
                loadingAux: true,
                statusOption: [
                    {value: "", label: "Selecione"},
                    {value: "Todos", label: "Todos"},
                    {value: "Emdia", label: "Em dia"}, 
                    {value: "Atrasada", label: "1 a 15 dias"},
                    {value: "Negativado", label: "Negativado"}, 
                    {value: "Protesto", label: "Protesto"}, 
                    {value: "Cobrancaextrajudicial", label: "Cobrança extrajudicial"},
                    {value: "Cobrancajudicial", label: "Cobrança judicial"}, 
                    {value: "Renegociada", label: "Renegociada"},
                ] 
            }
        },
        watch: {
            'status': function() {
                
                this.indexPage = 1;

                this.filtroSolicitacoes(this.status)
            }
        },
        methods: {
            async solicitacoesProcesso() {
                
                this.id = this.investidor._id;

                this.loading = true;

                const {data} = await CentralService.GetListagemSolicitacoesProcesso(this.indexPage);

                console.log("dados --> ", data);

                if (data) {
                    
                    this.Paginas = data.Paginas;
                    this.solicitacoes = data;
                    this.loading = false;
                }  

                return data;
           
            },
            async dadosTotalSolicitacoes() {

                const {data} = await CentralService.GetTotalSolicitacoesProcesso();

                console.log("dados --> ", data);

                if (data) {
                    
                    this.total = data;
                    this.loadingAux = false;
                } 
                return data;

            },
            async filtroSolicitacoes(status) {
                
                this.loading = true;

                const {data} = await CentralService.GetListagemSolicitacoesProcessoFiltro(this.indexPage, status);

                console.log("dados --> ", data); 

                if (data) {
                    
                    this.Paginas = data.Paginas;
                    this.solicitacoes = data;
                    this.loading = false;
                } 

            },
            async paginacao(rota){
                this.indexPage = rota + 1

                if (this.status != 'Todos' && this.status) {
                    await this.filtroSolicitacoes(this.status)
                } else {
                    await this.solicitacoesProcesso()
                }
            },
            formatarDinheiro(valor) {

                if (valor == undefined) return false;

                else if (valor == "") return false;

                valor = Number(valor);

                return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

            },
            formataData(date) {

                let spliter = date.split("T")
                let newDate = spliter[0].split('-')
                let time = spliter[1].split(':')

                return `${newDate[2]}/${newDate[1]}/${newDate[0]}`
            },
            abreviaStatus(status) {

                switch(status) {
                    case "Emdia":
                        return 'ed';
                    case "Em dia":
                        return 'ed';
                    case "15 dias":
                        return "15";
                    case "Negativado":
                        return "ngt";
                    case "Protesto":
                        return "pto";
                    case "Cobranca extrajudicial":
                        return "cej";
                    case "Cobrancaextrajudicial":
                        return "cej";
                    case "Cobranca judicial":
                        return "cj";    
                    case "Cobrancajudicial":
                        return "cj";    
                    case "Renegociada":
                        return "rng";
                }
            },

            //tagueamento GA
            taggingGA() {
                this.$ga.page({
                    page: '/central-de-cobranca/ ',
                    title: 'Central de Cobrança',
                })
            },
        },
        components: {
            Loading,
            Pagination
        },
        async created() {
            
            this.width = screen.width;

            this.investidor = this.$store.state.currentUser;

            this.$store.commit(mutationTypes.START_LOADING)

            await this.solicitacoesProcesso();
            await this.dadosTotalSolicitacoes();

            this.$store.commit(mutationTypes.STOP_LOADING)

            //tagueamento GA
            await this.taggingGA()
        },
    }
</script>

<style lang="scss" scoped>

    h2 {
        font-weight: normal;
        color: #666;
    }

    .paginacao {
        margin-top: 20px;

    }

    .tit_page {
        .back {
            a {
                span {
                    display: flex;

                    img {
                        width: 8px;
                        margin-right: 8px;
                    }
                }
            }
        }
    }

    .table {
        margin-top: 0px;
        margin-bottom: 0px;

        thead {
            th {
                border-top: none;
                text-align: center;
                font-size: 14px;
            }
        }

        tbody {
            tr {
                border-bottom: none;
                th, td {
                    text-align: center;
                    font-size: 14px;
                    color: #666;

                    a {
                        color: #666;
                        text-decoration: underline!important;

                        &:hover {
                            color: #333;
                        }
                    }
                }
            }
        }

        &-hover {
            tbody {
                tr:hover {
                    &:hover {
                        background: #f7f7f7;
                    }
                }
            }
        }
    }

    span {
        &.circle {
            display: block;
            width: 20px;
            height: 20px;
            border-radius: 1em;
        }

        &.status {
            &-ed {
                background-color: #6FC30E;
            }
            &-15 {
                background-color: #FFA700;
            }
            &-ngt {
                background-color: #FF4500;
            }
            &-pto {

                background-color: #FF0010;
            }
            &-cej {
                background-color: #8B0000;
            }  
            &-cj {
                background-color: #5B0000;
            }                        
            &-rng {
                background-color: #41D3BD;
            }
        }
    }

    aside {
        margin-top: 10px;

        ul {
            margin:0px;
            padding:0px;
        }

        li {
            &.header {
                border-bottom: 1px solid #DDDDDD;
                color:#666;
                padding-bottom: 8px;

                h3, 
                span {
                    font-size: 26px;
                    font-weight: normal;
                }
            }

            &.list {
                border-bottom: 1px solid #DDDDDD;
                font-size: 16px;
                padding: 8px 0;
                color: #666666;

                span {
                    &.circle {
                        margin-right: 8px;
                    }
                }

                i {
                    margin-left: 8px;
                }
            }

            &.total {
                padding-top: 8px;
                span {
                    font-size: 16px;
                    font-weight: bold;
                    color: #666666;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/CentralCobranca.vue